(function () {
  var DRAG_THRESHOLD = 6;

  function getStep(track) {
    var cards = track.querySelectorAll('[data-cards-categories-card]');
    if (cards.length > 1) {
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }
    return track.clientWidth;
  }

  function resetScroll(track) {
    // Browsers restore a scrollable element's previous scrollLeft on
    // reload/back-forward navigation, independent of layout — this makes
    // the leading spacer look "missing" until the user scrolls. Force it
    // back to the true start, including on bfcache restores.
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: 0, behavior: 'auto' });
    } else {
      track.scrollLeft = 0;
    }
  }

  // Mouse-only drag-to-scroll, same as cards-product-carousel.js. Touch/
  // pen already get native scrolling (overflow-x: auto) — hijacking those
  // pointer types here would fight the browser's own momentum scroll and
  // scroll-snap handling.
  function initDrag(track) {
    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var dragged = false;
    var suppressClick = false;

    function onPointerMove(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var delta = event.clientX - startX;
      if (!dragged) {
        if (Math.abs(delta) <= DRAG_THRESHOLD) return;
        dragged = true;
        track.classList.add('is-dragging');
        // Capture only after a real drag so a still press keeps pointerup
        // on the card <a> and the following click can navigate.
        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(pointerId);
        }
      }
      track.scrollLeft = startScrollLeft - delta;
    }

    function endDrag(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var wasDragged = dragged;
      if (
        typeof track.hasPointerCapture === 'function' &&
        track.hasPointerCapture(pointerId)
      ) {
        track.releasePointerCapture(pointerId);
      }
      pointerId = null;
      dragged = false;
      track.classList.remove('is-dragging');
      if (wasDragged) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 0);
        if (typeof track.scrollTo === 'function') {
          var reduce =
            window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({
            left: track.scrollLeft + 1,
            behavior: reduce ? 'auto' : 'smooth',
          });
        }
      }
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', endDrag);
      track.removeEventListener('pointercancel', endDrag);
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      dragged = false;
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    });

    track.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    // Cards are <a> elements wrapping an <img> — browsers start their own
    // native drag-and-drop gesture on those by default, which preempts
    // pointer events mid-press and makes the custom drag above feel like
    // it "doesn't work" whenever the press starts on the link/image.
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function initTrack(section) {
    var track = section.querySelector('[data-cards-categories-track]');
    var prevBtn = section.querySelector('[data-cards-categories-prev]');
    var nextBtn = section.querySelector('[data-cards-categories-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = max <= 1 || track.scrollLeft >= max - 1;
    }

    function scrollByStep(direction) {
      track.scrollBy({ left: getStep(track) * direction, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      scrollByStep(-1);
    });
    nextBtn.addEventListener('click', function () {
      scrollByStep(1);
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    initDrag(track);

    resetScroll(track);
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        resetScroll(track);
        update();
      });
    }
    update();
  }

  function init() {
    document.querySelectorAll('[data-cards-categories]').forEach(initTrack);
  }

  document.addEventListener('shopify:section:load', init);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
